import { render, staticRenderFns } from "./FarmAuthorizationStatus.vue?vue&type=template&id=dc7d7520&scoped=true&"
import script from "./FarmAuthorizationStatus.vue?vue&type=script&lang=ts&"
export * from "./FarmAuthorizationStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7d7520",
  null
  
)

export default component.exports